import { render, staticRenderFns } from "./ProcesosJefatura.vue?vue&type=template&id=2360d51d&"
import script from "./ProcesosJefatura.vue?vue&type=script&lang=js&"
export * from "./ProcesosJefatura.vue?vue&type=script&lang=js&"
import style0 from "./ProcesosJefatura.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VForm } from 'vuetify/lib/components/VForm';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VForm,VSpacer})
